import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useDispatch, useSelector } from 'react-redux';
import { useRef } from 'react';
import { useRouter } from 'next/router';

import { ButtonWrapper, PriceBarWrapper, SelectedProductsWrapper, StyledButton, TotalPriceWrapper } from './styles';
import { useByocNavigationContext } from '../../context/byoc-navigation-context';
import buildYourCoverActions from '../../../../actions/build-your-cover';
import ProductPricePill from './components/product-price-pill';
import ProductPriceTotal from './components/product-price-total';
import selectBuildYourCover from '../../../../selectors/select-build-your-cover';
import useAdjustFooterLinks from '../../../../elements/footer-links/utils/use-adjusted-footer-links';

const ReviewCoverButton = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { selectedProducts } = useSelector(selectBuildYourCover);
  const { journeyType } = useByocNavigationContext();

  const onReviewCoverClick = () => {
    buildYourCoverActions.submitReview(selectedProducts, router, journeyType)(dispatch);
  };

  return (
    <StyledButton onClick={onReviewCoverClick} variant={['purple', 'wide']}>
      Review cover
    </StyledButton>
  );
};

const PriceBar = () => {
  const priceBarRef = useRef<HTMLDivElement>(null);
  useAdjustFooterLinks(priceBarRef);
  const { journeyType } = useByocNavigationContext();

  return (
    <PriceBarWrapper ref={priceBarRef}>
      <SelectedProductsWrapper>
        {journeyType !== PRODUCT_TYPE.EXTRAS && <ProductPricePill productType={PRODUCT_TYPE.HOSPITAL} />}
        {journeyType !== PRODUCT_TYPE.HOSPITAL && <ProductPricePill productType={PRODUCT_TYPE.EXTRAS} />}
      </SelectedProductsWrapper>

      <TotalPriceWrapper data-testid="build-your-own-total-price">
        <ProductPriceTotal />
      </TotalPriceWrapper>

      <ButtonWrapper>
        <ReviewCoverButton />
      </ButtonWrapper>
    </PriceBarWrapper>
  );
};

export default PriceBar;
